import { capitalize, camelCase, snakeCase } from 'lodash-es'
export { capitalize, camelCase, snakeCase }

const WORDS = /\S+/g

// Public: Split on whitespace and return the resulting downcased tokens.
export function tokenize (words: string) {
  return (words && words.toLowerCase().match(WORDS)) || []
}

// Public: Separates camelCase or snake_case sentences into human readable sentences
//
// Example:
//   humanize('firstName') returns 'first name'
export function humanize (words: string) {
  return snakeCase(words).replace(/_/g, ' ')
}

// Public: Make each word in the string start with an uppercase letter, followed
// by lowercase letters.
//
// Example:
//   titleize('firstName') returns 'First Name'
export function titleize (words: string) {
  return humanize(words).replace(WORDS, capitalize)
}

export function pastTense (verb: string) {
  verb = verb.toLowerCase()
  return verb.endsWith('e') ? `${verb}d` : `${verb}ed`
}

// Public: Returns the initials of the specified name.
export function initials (name?: string) {
  return name?.split(' ').map(token => token[0]).slice(0, 2).join('') || ''
}

const IRREGULAR_PLURALS: Record<string, string> = {
  bonus: 'bonuses',
  has: 'have',
  history: 'history',
  is: 'are',
  person: 'people',
  was: 'were',
  Giftly: 'Giftlys', // will always be capitalized
}

const VOWELS = new Set(['a', 'e', 'i', 'o', 'u'])

// Public: Return singular or plural value based on a count
//
// Examples:
//   pluralize(1, 'invite') returns 'invite'
//   pluralize(2, 'invite') returns 'invites'
export function pluralize (count: number, singular: string) {
  const isCapitalized = singular[0] === capitalize(singular[0])
  const plural = count === 1 ? singular : IRREGULAR_PLURALS[singular.toLowerCase()] || buildPlural(singular)
  return isCapitalized ? titleize(plural) : plural
}

// Public: Build a plural from the singular
function buildPlural (word: string) {
  const lastLetter = word.slice(-1)
  if (lastLetter === 's') return word
  if (lastLetter === 'y' && !VOWELS.has(word.slice(-2, -1))) return `${word.slice(0, -1)}ies`
  return `${word}s`
}
